var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_1339_813)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.5498 0.246826C11.2432 0.246826 0.456055 11.0339 0.456055 24.3405C0.456055 37.6471 11.2432 48.4342 24.5498 48.4342C37.8563 48.4342 48.6435 37.6471 48.6435 24.3405C48.6435 11.0339 37.8563 0.246826 24.5498 0.246826ZM17.9666 34.8199V13.8612L36.1174 24.3405L17.9666 34.8199Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1339_813"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.1874,
    height: 48.1874,
    fill: "white",
    transform: "translate(0.456055 0.686768)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayVideo);
export default __webpack_public_path__ + "static/media/play_video.05d4b5b4a4595f53681269fd10292664.svg";
export { ForwardRef as ReactComponent };